var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDetermineYourInfrastructure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.890869,
    width: 194.218,
    height: 196,
    rx: 50,
    fill: "#D2BAFF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.546 38.3091H142.581C139.117 38.3091 136.309 41.1172 136.309 44.5811V60.5462C136.309 64.0101 139.117 66.8182 142.581 66.8182H158.546C162.01 66.8182 164.818 64.0101 164.818 60.5462V44.5811C164.818 41.1172 162.01 38.3091 158.546 38.3091Z",
    fill: "#A788FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5254 52.5636L135.919 52.5636",
    stroke: "#A788FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.818 73.9454L115.818 103.412",
    stroke: "#A788FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.818 73.9454C115.818 62.1366 106.245 52.5636 94.4364 52.5636",
    stroke: "#A788FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.818 103.345C115.818 114.472 123.891 123.724 134.527 125.618",
    stroke: "#A788FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.373 69.4909C117.154 77.5091 124.17 87.1583 135.418 89.0909",
    stroke: "#A788FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.9546,
    cy: 52.1182,
    r: 18.2636,
    fill: "url(#paint0_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.546 111.364H142.581C139.117 111.364 136.309 114.172 136.309 117.636V133.601C136.309 137.065 139.117 139.873 142.581 139.873H158.546C162.01 139.873 164.818 137.065 164.818 133.601V117.636C164.818 114.172 162.01 111.364 158.546 111.364Z",
    fill: "#A788FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.546 74.8364H142.581C139.117 74.8364 136.309 77.6444 136.309 81.1084V97.0735C136.309 100.537 139.117 103.345 142.581 103.345H158.546C162.01 103.345 164.818 100.537 164.818 97.0735V81.1084C164.818 77.6444 162.01 74.8364 158.546 74.8364Z",
    fill: "#A788FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.621 128.558C138.171 128.558 139.427 127.302 139.427 125.752C139.427 124.202 138.171 122.945 136.621 122.945C135.071 122.945 133.814 124.202 133.814 125.752C133.814 127.302 135.071 128.558 136.621 128.558Z",
    fill: "#7B3DE9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.972 92.0309C138.522 92.0309 139.778 90.7745 139.778 89.2245C139.778 87.6746 138.522 86.4182 136.972 86.4182C135.422 86.4182 134.165 87.6746 134.165 89.2245C134.165 90.7745 135.422 92.0309 136.972 92.0309Z",
    fill: "#7B3DE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.972 55.5036C138.522 55.5036 139.778 54.2472 139.778 52.6973C139.778 51.1474 138.522 49.8909 136.972 49.8909C135.422 49.8909 134.165 51.1474 134.165 52.6973C134.165 54.2472 135.422 55.5036 136.972 55.5036Z",
    fill: "#7B3DE9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.767 57.1802L149.289 55.4439H152.283L152.806 57.1802H155.464L152.47 48.1091H149.103L146.109 57.1802H148.767ZM149.847 53.6014L150.751 50.6072H150.822L151.725 53.6014H149.847Z",
    fill: "#D2BAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147 93.7074H151.27C153.241 93.7074 154.459 92.6311 154.459 91.1385C154.459 89.8584 153.515 89.0213 152.351 88.977V88.8884C153.4 88.6803 154.104 87.9051 154.104 86.9041C154.104 85.5222 153.006 84.6364 150.933 84.6364H147V93.7074ZM149.463 91.7409V89.8274H150.65C151.398 89.8274 151.854 90.1818 151.854 90.8196C151.854 91.4264 151.443 91.7409 150.614 91.7409H149.463ZM149.463 88.3038V86.5675H150.508C151.119 86.5675 151.571 86.8776 151.571 87.4356C151.571 87.9937 151.119 88.3038 150.473 88.3038H149.463Z",
    fill: "#D2BAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.613 124.689C154.418 122.439 152.771 121.164 150.485 121.164C148.04 121.164 146.109 122.794 146.109 125.823C146.109 128.84 147.987 130.483 150.485 130.483C153.143 130.483 154.489 128.64 154.613 127.099L152.115 127.081C151.991 127.856 151.442 128.339 150.538 128.339C149.338 128.339 148.643 127.489 148.643 125.823C148.643 124.246 149.316 123.307 150.556 123.307C151.504 123.307 152.044 123.865 152.115 124.689H154.613Z",
    fill: "#D2BAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.7637,
    y: 93.5455,
    width: 59.6909,
    height: 77.5091,
    rx: 9,
    fill: "#D2BAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.9636,
    y: 84.6364,
    width: 59.6909,
    height: 77.5091,
    rx: 9,
    fill: "white",
    stroke: "#A788FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0909,
    y: 93.5455,
    width: 40.0909,
    height: 5.34545,
    rx: 2.67273,
    fill: "#A788FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0909,
    y: 101.564,
    width: 32.0727,
    height: 2.67273,
    rx: 1.33636,
    fill: "#A788FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0909,
    y: 117.6,
    width: 41.8727,
    height: 2.67273,
    rx: 1.33636,
    fill: "#A788FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0909,
    y: 128.291,
    width: 41.8727,
    height: 2.67273,
    rx: 1.33636,
    fill: "#A788FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0909,
    y: 122.945,
    width: 38.3091,
    height: 2.67273,
    rx: 1.33636,
    fill: "#A788FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0909,
    y: 133.636,
    width: 22.2727,
    height: 2.67273,
    rx: 1.33636,
    fill: "#A788FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3483 145.069C56.7577 144.454 56.5918 143.625 55.9777 143.215C55.3636 142.806 54.5339 142.972 54.1245 143.586L48.779 151.604C48.3696 152.218 48.5356 153.048 49.1497 153.457C49.7638 153.867 50.5935 153.701 51.0029 153.087L56.3483 145.069ZM57.8067 153.239C57.3129 152.691 57.3574 151.846 57.906 151.352L61.2569 148.336L57.906 145.321C57.3574 144.827 57.3129 143.982 57.8067 143.433C58.3004 142.885 59.1454 142.84 59.694 143.334L63.4127 146.681C64.3958 147.566 64.3958 149.107 63.4127 149.992L59.694 153.339C59.1454 153.832 58.3004 153.788 57.8067 153.239ZM47.3207 143.433C47.8144 143.982 47.7699 144.827 47.2213 145.321L43.8705 148.336L47.2213 151.352C47.7699 151.846 47.8144 152.691 47.3207 153.239C46.8269 153.788 45.982 153.833 45.4334 153.339L41.7146 149.992C40.7315 149.107 40.7315 147.566 41.7146 146.681L45.4334 143.334C45.982 142.84 46.8269 142.885 47.3207 143.433Z",
    fill: "#A788FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.404 72.4438) rotate(-137.354) scale(61.1734 81.6277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837335,
    stopColor: "#A788FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDetermineYourInfrastructure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/determine_your_infrastructure.d517713aafa03f152bdcc0732fa7000b.svg";